<p-toast position="{{smallScreen ? 'bottom-right' : 'top-right'}}"></p-toast>
<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
    <button pButton type="button" 
            class="p-button p-button-text" 
            icon="pi-fw fas fa-chevron-circle-left" 
            label="Back" 
            (click)="returnToUserManagement()"></button>
  </div>
</p-toolbar>

<div class="p-fluid p-grid p-m-0" 
     style="background: var(--indigo-700);height: calc(100% - 36px); overflow: auto;">

  <div *ngIf="passwordReset" class="p-field p-md-offset-4 p-md-4">
    <p-card *ngIf="passwordReset" [style]="{'background': 'var(--surface-50)'}" [styleClass]="'p-shadow-12 p-mt-4 p-p-2 animate__animated animate__fadeIn'">

      <div class="p-fluid p-grid">
        <div class="text-left text-success p-col-12 p-mt-0">
          <h3 class="p-mt-0"><i class="far fa-thumbs-up text-xlarge"></i> Account {{resetPasswordViewModel.userName}} has been successfully reset! </h3>
        </div>
      </div>

      <div class="p-field p-col-12 p-mb-0">
        <div class="text-right">
          <button pButton pRipple label="Return" 
                  class="p-button p-button-raised p-button-primary" 
                  style="width:80px;"
                  icon="pi-fw fas fa-chevron-circle-left" 
                  type="button"
                  (click)="returnToUserManagement()"
                  ></button>
        </div>
      </div>
    </p-card>
  </div>

  <div *ngIf="!passwordReset" class="p-field p-md-offset-4 p-md-4">
    <p-card [style]="{'background': 'var(--surface-50)'}" [styleClass]="'p-shadow-12 p-mt-4 p-p-2 animate__animated animate__fadeIn'">
      <form #userForm="ngForm" 
            (ngSubmit)="resetPassword(userForm)">

        <div class="p-fluid p-grid">
          <h3 class="title title-left p-col-12 p-mt-0">Reset Password: {{resetPasswordViewModel.lastName}}, {{resetPasswordViewModel.firstName}}</h3>
        </div>

        <div class="p-fluid p-grid">
          <div class="p-field p-col-12">
            <label for="userName" class="required-field">Username</label>
            <span class="p-input-icon-right">
              <i class="far fa-user-circle"></i>
              <input type="text" id="userName" name="userName" pInputText 
                     [disabled]="true"
                     #userName="ngModel"
                     [(ngModel)]="resetPasswordViewModel.userName">
            </span>
          </div>
          
          <div class="p-field p-col-12">
            <label for="newPassword" class="required-field">Password</label>
            <p-password id="newPassword" name="newPassword" class="p-inputtext-sm" [toggleMask]="true"
                        required            
                        minlength="8"
                        #newPassword="ngModel"
                        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?=.*[-+_!@#$%^&*.,?])"
                        [class.field-error]="userForm.submitted && newPassword.invalid"
                        [(ngModel)]="resetPasswordViewModel.newPassword">
              <ng-template pTemplate="footer">
                  <ul class="p-pl-2 p-ml-2 p-mt-2 text-small" style="line-height: 1.5">
                    <li>At least one lowercase</li>
                    <li>At least one uppercase</li>
                    <li>At least one numeric</li>
                    <li>At least one non-alphanumeric: <strong>- + _ ! @ # $ % ^ & * . , ?</strong></li>
                    <li>Minimum 8 characters</li>
                  </ul>
              </ng-template>
            </p-password>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('required')">Password is required</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('minlength')">Password too short</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('notmatch')">Password not match</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('nolowercase')">At lease one lower case is required</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('nouppercase')">At least one upper case is required</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('nodigit')">At least one digit is required</small>
            <small class="p-error" *ngIf="userForm.submitted && newPassword.hasError('nonalphanumeric')">At least one non-alphanumeric character is required: - + _ ! @ # $ % ^ & * . , ?</small>
            
          </div>

          <div class="p-field p-col-12">
            <label for="confirmPassword" class="required-field">Confirm Password</label>
            <p-password id="confirmPassword" name="confirmPassword" class="p-inputtext-sm" [toggleMask]="true"
                        [promptLabel]="'Confirm the password'"
                        #confirmPassword="ngModel"
                        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?=.*[-+_!@#$%^&*.,?])"
                        [class.field-error]="userForm.submitted && confirmPassword.invalid"
                        [(ngModel)]="resetPasswordViewModel.confirmPassword">
            </p-password>
            <small class="p-error" *ngIf="userForm.submitted && confirmPassword.hasError('notmatch')">Password not match</small>
          </div>

          <div class="p-field p-mb-0 p-col-12 p-text-right">
            <div class="p-d-inline-block p-mr-1">
              <button pButton pRipple label="Reset Password" 
                      class="p-button p-button-raised p-button-danger p-button-sm" 
                      icon="pi pi-save" 
                      [disabled]="updating"
                      type="submit"></button>
            </div>
            <div class="p-d-inline-block">
              <button pButton pRipple label="Cancel" 
                      class="p-button p-button-raised p-button-outlined p-button-sm" 
                      icon="pi pi-times" 
                      (click)="returnToUserManagement()"
                      type="button"></button>
            </div>
          </div>

        </div>
      </form>
    </p-card>
  </div>
</div>